import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalContext';

const Error = () => {
  const { t } = useTranslation();
  const { error, siteInfo } = useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();

  const getErrorType = () => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('type') || error || 'default';
  };

  const errorType = getErrorType();

  const isPermanentError = (errorType) => {
    return ['unknown_site', 'unavailable_site'].includes(errorType);
  };

  useEffect(() => {
    if (isPermanentError(errorType)) {
      const handlePopState = (event) => {
        event.preventDefault();
        navigate('/error?type=' + errorType, { replace: true });
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [errorType, navigate]);

  const getErrorContent = (errorType) => {
    switch (errorType) {
      case 'no_card':
        return {
          title: t('Une erreur est survenue'),
          description: t('Votre lien sécurisé est expiré. Veuillez procéder à une nouvelle demande de lien en cliquant <a href="home">ici</a>.')
        };

      case 'unknown_site':
        return {
          title: t('Une erreur est survenue'),
          description: t('Le service est en maintenance et momentanément interrompu. Veuillez nous excuser pour le désagrément occasionné, nous travaillons à sa remise en ligne dans les plus brefs délais. Nous vous invitons à réessayer ultérieurement.')
        };

      case 'unavailable_site':
        return {
          title: t('Une erreur est survenue'),
          description: t('Le service est actuellement indisponible. Nous vous invitons à réessayer ultérieurement.')
        };

      default:
        return {
          title: t('Une erreur est survenue'),
          description: t('Veuillez réessayer plus tard')
        };
    }
  };

  const errorContent = getErrorContent(errorType);

  const handleHomeClick = (e) => {
    e.preventDefault();
    navigate('/');
  };

  const processDescription = (description) => {
    return description.replace(
      /<a href="home">/g,
      '<a href="/">'
    );
  };

  return (
    <div id="error" className="text-center">



      <h1 className="text-center">
        {t('Vos bons d\'achat {{ siteInfo.libelle }}', {
          'siteInfo.libelle': siteInfo?.libelle || ''
        })}
      </h1>
      <div><span className="glyphicon glyphicon-remove"></span></div>
      <h2>{errorContent.title}</h2>
      <div
        dangerouslySetInnerHTML={{
          __html: processDescription(errorContent.description)
        }}
        onClick={(e) => {
          if (e.target.tagName === 'A' && e.target.getAttribute('href') === '/') {
            handleHomeClick(e);
          }
        }}
      />
    </div>

  );
};

export default Error;